import { ref, pushScopeId, popScopeId, openBlock, createBlock, createVNode, withDirectives, withKeys, vModelText, Fragment, renderList, toDisplayString, withScopeId } from 'vue';

var script = {
  name: "TheList",
  props: {
    content: {
      type: Array,
      required: true,
      default: [["content1", "content2"], ["content3", "content4"]]
    },
    titles: {
      type: Array,
      required: true,
      default: ["title1", "title2"]
    },
    tableHeight: {
      type: [String, Number]
    },
    inputPlaceholder: {
      type: String,
      default: "Search..."
    },
    columnsWidth: {
      type: [String, Number],
      default: 100
    },
    darkModeOn: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    let searchText = ref("");
    let receiveContentList = ref(props.content);

    function searchFunc() {
      let filtredArray = [];
      if (isEmptyOrSpaces(searchText.value)) return receiveContentList.value = props.content;
      props.content.map(row => {
        row.map(item => {
          let itemLowCase = item.toLowerCase();
          let searchLowCase = searchText.value.toLowerCase();

          if (itemLowCase.includes(searchLowCase)) {
            let itemNotExist = filtredArray.indexOf(row) === -1;
            itemNotExist ? filtredArray.push(row) : null;
          }
        });
      });
      receiveContentList.value = filtredArray;
    }

    function isEmptyOrSpaces(str) {
      return str === null || str.match(/^ *$/) !== null;
    }

    return {
      searchText,
      searchFunc,
      receiveContentList
    };
  }

};

const _withId = /*#__PURE__*/withScopeId("data-v-52002de1");

pushScopeId("data-v-52002de1");

const _hoisted_1 = {
  class: "wrapper-search"
};

const _hoisted_2 = /*#__PURE__*/createVNode("svg", {
  class: "icon-search",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  heigth: "19",
  width: "19"
}, [/*#__PURE__*/createVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
  "clip-rule": "evenodd"
})], -1);

const _hoisted_3 = {
  class: "titles"
};
const _hoisted_4 = {
  class: "t-body"
};

popScopeId();

const render = /*#__PURE__*/_withId((_ctx, _cache, $props, $setup, $data, $options) => {
  return openBlock(), createBlock("div", {
    class: ["table standard", {
      'dark-mode': $props.darkModeOn
    }],
    style: {
      height: $props.tableHeight + 'px'
    }
  }, [createVNode("div", _hoisted_1, [withDirectives(createVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.searchText = $event),
    type: "text",
    class: "search",
    placeholder: $props.inputPlaceholder,
    onKeyup: _cache[2] || (_cache[2] = withKeys((...args) => $setup.searchFunc && $setup.searchFunc(...args), ["enter"]))
  }, null, 40, ["placeholder"]), [[vModelText, $setup.searchText]]), createVNode("button", {
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.searchFunc && $setup.searchFunc(...args)),
    class: "button-search"
  }, [_hoisted_2])]), createVNode("div", _hoisted_3, [(openBlock(true), createBlock(Fragment, null, renderList($props.titles, (title, index) => {
    return openBlock(), createBlock("p", {
      style: {
        width: $props.columnsWidth + 'px'
      },
      key: index
    }, toDisplayString(title), 5);
  }), 128))]), createVNode("div", _hoisted_4, [(openBlock(true), createBlock(Fragment, null, renderList($setup.receiveContentList, (array, index) => {
    return openBlock(), createBlock("div", {
      key: index,
      class: "items"
    }, [(openBlock(true), createBlock(Fragment, null, renderList(array, (item, index) => {
      return openBlock(), createBlock("p", {
        style: {
          width: $props.columnsWidth + 'px'
        },
        key: index
      }, toDisplayString(item), 5);
    }), 128))]);
  }), 128))])], 6);
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "\n@import url(\"https://fonts.googleapis.com/css2?family=Varela+Round&display=swap\");\n.standard[data-v-52002de1] {\n  --background: #fff;\n  --color-1: #f0f0f7;\n  --color-2: #b1b3c4;\n  --color-3: #f5f5f7;\n  --color-4: #e4e5f1;\n  --color-5: #4b4a54;\n}\n.dark-mode[data-v-52002de1] {\n  --background: #151618;\n  --color-1: #202224;\n  --color-2: #bfc0c1;\n  --color-3: #191a1c;\n  --color-4: #27282c;\n  --color-5: #b9b9ba;\n}\n[data-v-52002de1]::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* Track */\n[data-v-52002de1]::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n/* Handle */\n[data-v-52002de1]::-webkit-scrollbar-thumb {\n  background: var(--color-4);\n  border-radius: 5px;\n}\np[data-v-52002de1] {\n  margin: 0;\n  padding: 0;\n}\n.table[data-v-52002de1] {\n  background: var(--background);\n  border-radius: 5px;\n  padding: 20px;\n  width: fit-content;\n  height: fit-content;\n  font-family: \"Varela Round\", sans-serif;\n  font-weight: 600;\n  position: relative;\n  overflow-y: auto;\n}\n.titles[data-v-52002de1] {\n  display: flex;\n  flex-direction: row;\n  background: var(--color-1);\n  padding: 15px 0;\n  border-radius: 5px;\n}\n.titles p[data-v-52002de1] {\n  padding: 0 10px;\n  color: var(--color-2);\n}\n.items[data-v-52002de1] {\n  display: flex;\n  flex-direction: row;\n  margin-top: 5px;\n  padding: 10px 0;\n  color: var(--color-5);\n  transition: all 0.3s ease 0s;\n}\n.items[data-v-52002de1]:nth-child(even) {\n  background-color: var(--color-3);\n  border-radius: 5px;\n}\n.items[data-v-52002de1]:hover {\n  background: var(--color-1);\n  border-radius: 5px;\n}\n.items p[data-v-52002de1] {\n  padding: 0 10px;\n}\n.t-body[data-v-52002de1] {\n  margin-top: 20px;\n}\n.search[data-v-52002de1] {\n  height: 35px;\n  width: 50%;\n  max-width: 500px;\n  border-radius: 20px;\n  outline: none;\n  border: 3px solid var(--color-1);\n  padding: 0 20px;\n  font-family: \"Varela Round\", sans-serif;\n  color: var(--color-5);\n  background: var(--background);\n}\n.wrapper-search[data-v-52002de1] {\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n}\n.icon-search[data-v-52002de1] {\n  fill: var(--color-2);\n}\n.search[data-v-52002de1]::placeholder {\n  color: var(--color-4);\n  font-weight: bold;\n  font-size: 15px;\n}\n.button-search[data-v-52002de1] {\n  margin-left: -45px;\n  border-radius: 20px;\n  height: 30px;\n  width: 40px;\n  border: 0;\n  outline: none;\n  cursor: pointer;\n  background-color: var(--color-1);\n  transition: all 0.3s ease 0s;\n}\n.button-search[data-v-52002de1]:hover {\n  background-color: var(--color-4);\n}\n";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-52002de1";

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Get component instance
  const installable = script; // Attach install function executed by Vue.use()

  installable.install = app => {
    app.component('VueJsList', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export default entry_esm;
